/* eslint-disable import/no-unresolved -- eslint import resolve don't understand these definitions */
import * as VoximplantSdk from "voximplant-websdk"
import type { MediaRenderer } from "voximplant-websdk/Media/MediaRenderer"
export type { Endpoint } from "voximplant-websdk/Call/EndPoints/Endpoint"
export type { Client } from "voximplant-websdk/Client"
export type { Call } from "voximplant-websdk/Call/Call"
export type { EventHandlers } from "voximplant-websdk/EventHandlers"
export type { AudioSourceInfo, VideoSourceInfo } from "voximplant-websdk/Structures"
export type { AudioParams } from "voximplant-websdk/Hardware/src/AudioParams"
export type {
    InboundAudioStatsReport,
    OutboundAudioStatsReport,
} from "voximplant-websdk/Stats/v5/StatsReport"
/* eslint-enable import/no-unresolved */

const AudioDeviceManager = VoximplantSdk.Hardware.AudioDeviceManager
const CameraManager = VoximplantSdk.Hardware.CameraManager

export { AudioDeviceManager, CameraManager, VoximplantSdk }

export type Endpoints = Record<string, MediaRenderer | undefined>
export type InputDeviceManager = typeof CameraManager | typeof AudioDeviceManager

export type InputDevice = Awaited<
    ReturnType<ReturnType<InputDeviceManager["get"]>["getInputDevices"]>
>[0]

export type { MediaRenderer }
